import { Browser } from '@capacitor/browser';
import type { LogoutOptions, RedirectLoginOptions } from '@auth0/auth0-react';

export interface AuthLogoutFunction {
  (options?: LogoutOptions): Promise<void>;
}

export interface AuthLoginFunction {
  (options?: RedirectLoginOptions): Promise<void>;
}

export const performLogout = async (
  logout: AuthLogoutFunction,
  options: {
    returnTo: string;
    isMobile: boolean;
  }
): Promise<void> => {
  if (options.isMobile) {
    try {
      // For mobile: use localOnly to avoid Auth0's browser redirect
      // This clears tokens locally without going through Auth0's logout page
      await logout({
        logoutParams: {
          returnTo: options.returnTo,
        },
        async openUrl(url) {
          await Browser.open({ url });
        }
      });
    } catch (error) {
      console.error('[Logout] Error during logout:', error);
    }
  } else {
    await logout({
      logoutParams: {
        returnTo: options.returnTo
      }
    });
  }
};

export const performLogin = async (
  loginWithRedirect: AuthLoginFunction,
  options: {
    returnTo?: string;
    isMobile: boolean;
    authorizationParams?: Record<string, string>;
  }
): Promise<void> => {
  const loginOptions: RedirectLoginOptions = {
    appState: {
      returnTo: options.returnTo || '/app'
    },
    ...(options.authorizationParams && { authorizationParams: options.authorizationParams })
  };

  if (options.isMobile) {
    await loginWithRedirect({
      ...loginOptions,
      async openUrl(url) {
        await Browser.open({ url });
      }
    });
  } else {
    await loginWithRedirect(loginOptions);
  }
};

export const getAuthRedirectUri = (isMobile: boolean, path: string = 'landing'): string => {
  return isMobile
    ? `com.futyclub.app://${path}`
    : `${window.location.origin}/${path}`;
};
